'use strict';

angular.module('selfAccessRequestControllers.AdHoc', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'services.search',
    'selfAccessRequestSharedControllers']);